import IconTitleList from '../../molecules/iconTitleList/IconTitleList';
import classes from './ThreeColumnIconGrid.module.scss';

export default function ThreeColumnIconGrid({ data }) {
    return (
        <div className={`${classes.oThreeColumn} ${classes[`${data.theme}`]}`}>
            <div className={`container`}>
                <h2 className={classes.aTitle}>{data.title}</h2>
                <div className={`row`}>
                    <IconTitleList data={data} />
                </div>
            </div>
        </div>
    );
}
